module.exports = __webpack_public_path__ + "static/media/xdai.b17847f3.svg";